import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { pxToRems } from '@awaze/design-system.utils.react';
export const sizesConfig = {
    'x-small': {
        fontSize: pxToRems(14),
        lineHeight: pxToRems(14),
        bulletSize: 3,
        iconSize: pxToRems(12),
        iconMargin: pxToRems(4),
        indentSize: pxToRems(16),
        iconPopSize: pxToRems(24),
        fontWeight: pxToRems(400),
    },
    small: {
        fontSize: pxToRems(14),
        lineHeight: pxToRems(24),
        bulletSize: 4,
        iconSize: pxToRems(16),
        iconMargin: pxToRems(8),
        indentSize: pxToRems(20),
        iconPopSize: pxToRems(32),
        fontWeight: pxToRems(400),
    },
    medium: {
        fontSize: pxToRems(16),
        lineHeight: pxToRems(24),
        bulletSize: 5,
        iconSize: pxToRems(20),
        iconMargin: pxToRems(8),
        indentSize: pxToRems(24),
        iconPopSize: pxToRems(40),
        fontWeight: pxToRems(400),
    },
    large: {
        fontSize: pxToRems(24),
        lineHeight: pxToRems(24),
        bulletSize: 6,
        iconSize: pxToRems(24),
        iconMargin: pxToRems(12),
        indentSize: pxToRems(28),
        iconPopSize: pxToRems(48),
        fontWeight: pxToRems(500),
    },
};
export const UnstyledListItem = styled.li `
  list-style: none;
`;
export const StyledListItem = styled.li `
  ${({ size, theme, indent, onClick }) => css `
    font-size: ${sizesConfig[size].fontSize};
    line-height: ${sizesConfig[size].lineHeight};
    display: flex;
    align-items: center;
    overflow: hidden;
    color: ${theme.ColorGrey800};
    ${indent &&
    css `
      padding-left: ${sizesConfig[size].indentSize};
    `}
    ${onClick &&
    css `
      cursor: pointer;
    `}
  `}
`;
export const StyledIconContainer = styled.div `
  ${({ size, iconPosition, iconPop, dense, theme }) => css `
    display: flex;
    align-items: center;
    ${!dense &&
    css `
      width: ${sizesConfig[size].iconSize};
      margin: 0 ${sizesConfig[size].iconMargin};
      margin-${iconPosition}: 0;
   `}

    svg {
      width: ${sizesConfig[size].iconSize};
      height: auto;
    }

    ${iconPop &&
    css `
      justify-content: center;
      border-radius: 50%;
      width: ${sizesConfig[size].iconPopSize};
      height: ${sizesConfig[size].iconPopSize};
      background: ${theme.ColorBlackOpacity5};
    `}
  `}
`;
const StyledBulletContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ size }) => sizesConfig[size].iconSize};
`;
export const Bullet = ({ size }) => {
    const { bulletSize } = sizesConfig[size];
    return (_jsx(StyledBulletContainer, { size: size, children: _jsx("svg", { width: bulletSize, height: bulletSize, viewBox: `0 0 ${bulletSize} ${bulletSize}`, fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("circle", { cx: bulletSize / 2, cy: bulletSize / 2, r: bulletSize / 2, fill: "currentColor" }) }) }));
};
//# sourceMappingURL=list-item.styles.js.map